<template>
    <div class="erm_menu_container">
        <div class="easyRestaurantManager-special-menu">
            <h2>{{ settings?.category_title }}</h2>
            <p>{{ settings?.category_short_desc }}</p>
            <div class="easyRestaurantManager-menu-categories">
                <div v-for="(category, index) in categories" :key="index" class="easyRestaurantManager-menu-category">
                    <a href="#">
                        <div class="erm_category_img">
                            <img :alt="category.name" :src="imageUrl + category.image" width="100" />
                        </div>
                        <p>{{ category.name }}</p>
                    </a>
                </div>
            </div>
        </div>
        <div class="easyRestaurantManager-menu-sections">
            <div class="easyRestaurantManager-menu-title">
                <h2>{{ settings?.category_title }}</h2>
                <p>{{ settings?.category_short_desc }}</p>
            </div>

            <div v-for="(section, index) in menuSections" :key="index" class="easyRestaurantManager-menu-section">
                <div class="erm_menu_item_title">
                    <p>• MENU & PRICING</p>
                    <h3>{{ section.name }}</h3>
                </div>
                <div class="easyRestaurantManager-menu-items">
                    <div @click="openModal(getGlobalIndex(index, itemIndex))" v-for="(item, itemIndex) in section.items" :key="itemIndex" :class="settings?.menu_single_page == 'yes' ? 'easyRestaurantManager-menu-item easyRestaurantManager-menu-details-page' : 'easyRestaurantManager-menu-item'">
                        <div class="erm_menu_item_img">
                            <img :alt="item.name" :src="imageUrl + item.image" height="60" width="60" />
                        </div>
                        <div class="easyRestaurantManager-menu-item-info">
                            <h4>{{ item.name }}</h4>
                            <p>{{ item.description }}</p>
                        </div>
                        <div class="easyRestaurantManager-menu-item-right">
                            <div class="easyRestaurantManager-menu-item-price">${{ item.price }}</div>
                            <!-- <div @click="()=> detailsShow = true" class="easyRestaurantManager-menu-item-details">Details</div> -->
                        </div>
                        <StandardDetails v-if="settings?.menu_single_page == 'yes'" :item="item" ref="menu_details_modal" :dialogVisible="dialogVisible"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import StandardDetails from './Standard_details.vue';
export default {
    components: {
        StandardDetails
    },
    props: {
        settings: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            dialogVisible: false,
            imageUrl: window.RestaurantMenuMangeData.assets_url + '/images/',
            categories: [
                {
                    name: "Starters",
                    image: "cat.jpg"
                },
                {
                    name: "Vegetables",
                    image: "cat.jpg"
                },
                {
                    name: "Seafood",
                    image: "cat.jpg"
                },
                {
                    name: "Desserts",
                    image: "cat.jpg"
                },
                {
                    name: "Beverages",
                    image: "cat.jpg"
                }
            ],
            menuSections: [
                {
                    name: "STARTERS",
                    items: [
                        {
                            name: "Spring Rolls",
                            description: "Crispy rolls filled with vegetables, served with dipping sauce.",
                            price: 14.00,
                            image: "cat.jpg"
                        },
                        {
                            name: "Paneer Tikka",
                            description: "Grilled paneer cubes, spiced to perfection.",
                            price: 20.00,
                            image: "cat.jpg"
                        }
                    ]
                },
                {
                    name: "LUNCH",
                    items: [
                        {
                            name: "Aloo Tikki",
                            description: "Golden potato patties served with chutney.",
                            price: 12.00,
                            image: "cat.jpg"
                        },
                        {
                            name: "Hara Kebab",
                            description: "Green vegetable and herb kebabs, grilled to perfection.",
                            price: 16.00,
                            image: "cat.jpg"
                        },
                        {
                            name: "Veg Pakoras",
                            description: "Crispy vegetable fritters with a dip.",
                            price: 10.00,
                            image: "cat.jpg"
                        }
                    ]
                },
                {
                    name: "DINNER",
                    items: [
                        {
                            name: "Spring Rolls",
                            description: "Crispy rolls filled with vegetables, served with dipping sauce.",
                            price: 14.00,
                            image: "cat.jpg"
                        },
                        {
                            name: "Paneer Tikka",
                            description: "Grilled paneer cubes, spiced to perfection.",
                            price: 20.00,
                            image: "cat.jpg"
                        },
                        {
                            name: "Chili Mushrooms",
                            description: "Spicy, crispy mushrooms with a tangy twist.",
                            price: 18.00,
                            image: "cat.jpg"
                        },
                        {
                            name: "Aloo Tikki",
                            description: "Golden potato patties served with chutney.",
                            price: 12.00,
                            image: "cat.jpg"
                        },
                        {
                            name: "Hara Kebab",
                            description: "Green vegetable and herb kebabs, grilled to perfection.",
                            price: 16.00,
                            image: "cat.jpg"
                        },
                        {
                            name: "Veg Pakoras",
                            description: "Crispy vegetable fritters with a dip.",
                            price: 10.00,
                            image: "cat.jpg"
                        }
                    ]
                }
                // You can add more sections here, e.g. "Main Course", "Desserts", etc.
            ]
        }
    },
    methods: {
        openModal(itemIndex) {
            console.log(this.$refs.menu_details_modal)
            this.$refs.menu_details_modal[itemIndex].openModel()
        },
        getGlobalIndex(sectionIndex, itemIndex) {
        let globalIndex = itemIndex;
        for (let i = 0; i < sectionIndex; i++) {
            globalIndex += this.menuSections[i].items.length;
        }
        return globalIndex;
    }
    }
}
</script>